<template>
  <div
    style="    min-height: 88vh;
    background: #fff;
    margin: 24px;"
  >
    <top-title name="会员等级/积分设置" style="margin: 20px 20px 0 20px; min-width: 1100px"></top-title>
    <div class="memberLevel">
      <!-- 头部提示 -->
      <div class="headTips" style="padding: 20px 20px;background:#fff">
        <div class="details tipBg" style="background: #fffaee; padding: 10px; width: 100%">
          <img
            src="@/assets/images/new_icon_reminder.png"
            style="
              display: inline-block;
              float: left;
              width: 14px;
              height: 14px;
              color: #ffffff;
              margin: 3px 4px 0px 3px;
            "
          />
          <p>
            1. 使用会员积分功能之前，需先开通官方
            <span class="strong">“会员等级”</span>功能，在官方设置各个会员等级需要进行的消费条件。会员等级开通地址：
            <span class="set" v-zoom="{ from: pageName, name: '去开通会员等级' }" @click="toSetting">点击设置</span>
          </p>
          <p style="margin-left:20px">
            2.“会员等级”设置完成后，开通官方
            <span class="strong">“店铺积分功能”</span>。设置好不同等级会员订单赠送积分数量。店铺积分开通地址：
            <span class="set" v-zoom="{ from: pageName, name: '去开通店铺积分' }" @click="toSetting">点击设置</span>
          </p>
          <p style="margin-left:20px;">
            <span class="strong" style="color:#333333">3. 如果开通历史积分补分，请检查积分补发公式，避免意外送出大量积分。</span>
          </p>
        </div>
      </div>

      <!-- 表格内容 -->
      <div class="tableWrap">
        <!-- 顶部按钮 -->
        <div class="headBtns">
          <button class="b1" v-zoom="{ from: pageName, name: '去设置会员折扣' }" @click="jingdongdenglu">
            <img src="../../../assets/images/set_icon.png" class="icon" />
            去设置会员折扣
          </button>
          <button class="b2" v-zoom="{ from: pageName, name: '去设置会员等级' }" @click="jingdongdenglu">去设置会员等级</button>
          <button class="b3" v-zoom="{ from: pageName, name: '去设置积分倍数' }" @click="jingdongdenglu">去设置积分倍数</button>
        </div>
        <!-- 表格 -->
        <el-table
          :data="tableData"
          v-loading="talbeLoading"
          style="width: 100%; margintop: 20px; border: 1px solid #f0f0f0"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
        >
          <template slot="empty">
            <div>
              <img src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png" />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column prop="customerLevelName" label="会员等级名称"></el-table-column>
          <el-table-column label="自定义名称（无线端展示）" width="200px">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.levelCustomName"
                @change="setmemberLevel1(scope.row.customerLevel, scope.row.levelCustomName)"
                style="width: 125px; marginright: 8px"
                maxlength="7"
              ></el-input>
              <span class="custom">{{ scope.row.levelCustomName.length }}/7</span>
            </template>
          </el-table-column>
          <el-table-column label="等级达成条件" width="450px;">
            <template slot-scope="scope">
              <span v-if="scope.row.minOrderCount == 0 && scope.row.minOrderPrice == 0">所有开卡入会的用户</span>
              <span v-if="scope.row.minOrderCount != 0 && scope.row.minOrderPrice != 0"
                >累计在店铺消费金额满{{ scope.row.minOrderPrice }}元或交易次数达到{{ scope.row.minOrderCount }}次</span
              >
            </template>
            <!-- <template slot-scope="scope">
            <span v-if="scope.row.minOrderCount!=0&&scope.row.minOrderPrice!=0">累计在店铺消费金额满{{scope.row.minOrderPrice}}元或交易次数达到{{scope.row.minOrderCount}}次</span>
          </template> -->
            <!-- <template v-solt="scope"> -->

            <!-- <span if="tableData.minOrderCount==0 ? '所有买过本店商品客户' : '累计在店铺消费金额满{{}}元或交易次数达到{{}}次'"></span> -->
            <!-- </template> -->
          </el-table-column>
          <el-table-column prop="pointMultiple" label="订单积分（倍）"></el-table-column>
          <el-table-column prop="discount" label="会员折扣（折）"></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import topTitle from "../../../components/top-title";
import { querymemberLevel, setmemberLevel } from "@/api/integralCenter/memberLevel";

export default {
  components: {
    topTitle,
  },
  data() {
    return {
      pageName: "忠诚度管理-会员等级",
      talbeLoading: true, // 控制表格loading状态
      tableData: [],
      formDataList: [],
      aaa: [],
    };
  },
  created() {
    this.queryList();
  },
  methods: {
    //查询将接口数据显示出来
    queryList() {
      querymemberLevel()
        .then((res) => {
          this.talbeLoading = false;
          this.tableData = res.data;
          // res.data.forEach((item) => {
          //   // aaa.push(item);
          //   this.aaa =item;
          //   console.log(item.levelCustomName);
          // });
          console.log(this.tableData);
          // for(let i=0; i<this.tableData.length; i++){
          //   console.log(this.tableData[i].minOrderCount);}
        })
        .catch((res) => {});
    },
    setmemberLevel1(level, name) {
      this.talbeLoading = true;
      setmemberLevel({ level: level, name: name })
        .then((res) => {
          this.talbeLoading = false;
          this.$message.success("修改成功");
          this.queryList();
        })
        .catch((res) => {});
    },

    //跳转到京东商家登录
    jingdongdenglu() {
      // window.location.href = 'https://passport.shop.jd.com/login/index.action?ReturnUrl=https%3A%2F%2Fshop.jd.com%2F';
      window.open("https://crm.shop.jd.com/crm/shopNewLevel/index.action#/newmemberlevel");
    },

    //去设置页面
    toSetting() {
      // this.$router.push({
      //   path: "/backstage",
      //   query: { to: "/backstage/smsmanage/charge" },
      // });
      // window.open(routeUrl.href, "_blank");
      window.open("https://crm.shop.jd.com/crm/shopNewLevel/index.action#/newmemberlevel");
    },
  },
};
</script>

<style scoped lang="scss">
.memberLevel {
  box-sizing: border-box;
  padding: 0 20px;
  min-width: 1100px;
  .headTips {
    display: flex;
    box-sizing: border-box;
    padding: 0 20px;
    min-width: 1100px;
    .headTips {
      display: flex;
      box-sizing: border-box;
      padding: 5px 12px;
      width: 100%;
      height: 70px;
      margin-top: 20px;
      background: rgba(255, 244, 244, 1);
      border: 1px solid rgba(254, 143, 138, 1);
      i {
        margin: 3px 5px 0 0;
        color: #7b61ff;
        font-size: 14px;
      }
      .details {
        p {
          margin: 0;
          line-height: 20px;
          font-size: 14px;
          color: #333;
          font-weight: 400;
          .strong {
            color: #7b61ff;
          }
          .set {
            cursor: pointer;
          }
        }
      }
    }
    .details {
      p {
        margin: 0;
        line-height: 20px;
        font-size: 13px;
        color: #333;
        font-weight: 400;
        .strong {
          color: #7b61ff;
        }
        .set {
          cursor: pointer;
          color: #7f85e9;
          &:hover {
            color: #7b61ff;
          }
        }
      }
    }
  }
  .tableWrap {
    box-sizing: border-box;
    padding: 0px 28px 30px 24px;
    background: rgba(255, 255, 255, 1);
    border-radius: 6px;
    .headBtns {
      display: flex;
      align-items: center;
      button {
        min-width: 122px;
        height: 32px;
        line-height: 28px;
        background-color: white;
        outline: none;
        cursor: pointer;
        text-align: center;
        transition: all 0.2s;
        border-radius: 3px;
        border: none;
      }
      .b1 {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 138px;
        color: #fff;
        margin-bottom: 20px;
        background-color: #7b61ff;
        &:hover {
          opacity: 0.9;
        }
        .icon {
          margin-right: 2px;
          width: 12px;
          height: 12px;
        }
      }
      .b2 {
        margin: 0 12px 20px 12px;
      }
      .b2,
      .b3 {
        border: 1px solid #7b61ff;
        color: #7b61ff;
        margin-bottom: 20px;
        &:hover {
          background-color: #7b61ff;
          color: #fff;
        }
      }
    }
    .custom {
      display: inline-block;
      padding: 10px 0;
      margin-left: 4px;
    }
    /deep/ .el-table .el-table__header-wrapper th .cell {
      text-align: center;
    }
    /deep/ .el-table .el-table__header-wrapper th {
      border-right: 1px solid #f0f0f0;
      &:last-child {
        border-right: none;
      }
    }
    /deep/ .el-table--enable-row-transition .el-table__body td {
      text-align: center;
      border-right: 1px solid #f0f0f0;
      &:last-child {
        border-right: none;
      }
    }
  }
}
</style>
